import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { mapParamsBySchema } from '../../../../util';
import { DAT_BASIC_Schema } from './DAT_BASIC_Schema';

/** 전체 페이지 일괄 이관 — API 1회 (서버에서 등록된 모든 페이지 쿼리 실행) */
export const useCopy1 = (options = {}) => {
  return useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(DAT_BASIC_Schema.mapper.copy1, context);

    return apiRequest(
      'post',
      Global.urls.DataMigration.copyDatBasicU1,
      payload
    );
  }, options);
};

/** 특정 페이지만 이관 — API 1회 (ProId 해당 페이지 쿼리만 실행) */
export const useCopy2 = (options = {}) => {
  return useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(DAT_BASIC_Schema.mapper.copy2, context);

    return apiRequest(
      'post',
      Global.urls.DataMigration.copyDatBasicU2,
      payload
    );
  }, options);
};

/** 예산관리(BUD_BASIC) 대상 사업장 데이터 삭제 */
export const useDelete1 = (options = {}) => {
  return useSaveMutation(async (context) => {
    const payload = mapParamsBySchema(DAT_BASIC_Schema.mapper.delete1, context);

    return apiRequest(
      'post',
      Global.urls.DataMigration.deleteDatBasicU1,
      payload
    );
  }, options);
};
